import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 112 102.9",
  x: "0px",
  y: "0px",
  xmlns: "http://www.w3.org/2000/svg",
  "xml:space": "preserve",
  "xmlns:xlink": "http://www.w3.org/1999/xlink"
}
const _hoisted_2 = ["fill"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [
    _createElementVNode("path", {
      d: "M55.9,30.6l-30.1-8.9l18.5,20.7L0,53.3l46,3l-6,21.2l18.2-17l1.8,42.4l14.5-39.4L112,86L79.3,48.4 l28.5-5.4l-32.7-9.1L58.7,0L55.9,30.6z",
      fill: $props.color
    }, null, 8, _hoisted_2)
  ]))
}